<button
  type="button"
  class="progress-chip progress-chip--{{ item.status }}"
  [attr.aria-label]="item.name"
  [title]="item.name"
  (click)="chipClick.emit(item.id)"
>
  <img
    class="progress-chip__logo"
    [class.progress-chip__logo--sized]="item.chipLogo.width"
    [src]="item.chipLogo.src"
    [style.width.px]="item.chipLogo.width"
    [style.height.px]="item.chipLogo.height"
    [alt]="item.name"
  />
  <app-progress-status-icon
    [status]="item.status"
    [readyOrder]="item.readyOrder"
  ></app-progress-status-icon>
</button>
